import { Link } from "react-router-dom";
import { Timer, Zap } from "lucide-react";
import { OVERTIME_WORKS_PATH, PREMIUM_WORKS_PATH } from "../../Moduels/Salary/v2/extraWorkPolicy";
import "../../styles/extraWorkConfig.css";

export default function ExtraWorkConfigLink() {
  return (
    <div className="ewc-link-stack">
      <Link to={OVERTIME_WORKS_PATH} className="ewc-link-card">
        <Timer size={18} strokeWidth={1.75} aria-hidden />
        <div>
          <h3>Overtime Works</h3>
          <p>
            Enable OT, choose hours source, OT pay calculation, eligibility, and OT payroll approval.
          </p>
        </div>
        <span>Open →</span>
      </Link>
      <Link to={PREMIUM_WORKS_PATH} className="ewc-link-card">
        <Zap size={18} strokeWidth={1.75} aria-hidden />
        <div>
          <h3>Premium Works</h3>
          <p>
            Sunday work, holiday work, premium multipliers, and compensatory off policy.
          </p>
        </div>
        <span>Open →</span>
      </Link>
    </div>
  );
}
